export default "__VITE_ASSET__BoFS35Y$__"